// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    /*Application Environment*/
    environment: 'prod',
    /* Application Urls & Phone numbers */
    awanaUrl: 'https://www.awana.org',
    awanaDonate: 'https://www.awana.org/donate',
    awanaStore: 'https://www.awana.org/shop',
    aboutAwanaUrl: 'https://www.awana.org/about',
    contactAwanaUrl: 'https://www.awana.org/contact/',
    wpAwanaUrl: 'https://www.awana.org/wp-login.php',
    customerCarePhoneNumber: '(866) 292-6227',
    eventsAwanaUrl: 'https://events.awana.org',
    myAwanaUrl: 'https://my.awana.org/',
    awanaCareersUrl: 'https://www.awana.org/careers',
    awanaCopyRightUrl: 'https://www.awana.org/copyright-information',
    awanaFundRaising: 'https://www.awana.org/fundraising-disclosure',
    awanaPrivacyPolicy: 'https://www.awana.org/privacy-policies',
    awanaSocialMediaPolicy: 'https://www.awana.org/social-media-policies',
    facebookUrl: 'https://www.facebook.com/AwanaHQ',
    twitterUrl: 'https://twitter.com/Awana',
    instagramUrl: 'https://www.instagram.com/awana/#',
    youtubeUrl: 'https://www.youtube.com/channel/UCux3DZHEysGzw6e-JmktmHA',
    pinterestUrl: 'https://www.pinterest.com/awana/',
    missionarySiteHost: 'missionary.awana.org',

    /* Service Configuration */
    services: {
      user: { url: 'https://prod1.my.awana.org/user-service/', port: 3000 },
      church: {url: 'https://prod1.my.awana.org/church-service/', port : 5000},
      eventmanagement: { url: 'https://prod1.my.awana.org/event-management-service/', port: 7200 }
    },
    captchaKey:"6LeW1l4UAAAAAJb6AjveCl4Q7M8aYiov4Q7Iw5Ek",
    
    keycloakConfig: {
    url: 'https://login.awana.org/auth/',
    realm: 'awana',
    clientId: 'events.awana.org'
    },
    superAdminEmailId: 'chipr@awana.org,joshh@awana.org,lloydm@awana.org,jasons@awana.org,kylelp@awana.org,robinc@awana.org,partnercare@awana.org',
    googleAnalyticsId: 'UA-1265584-53',
    googleTagManagerId: "GTM-MK5HRTK",
    braintreeId: "production_7bwsh5hz_wbb3xz2w6x49c9vx"
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
